var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import JetButton from '@/Jetstream/Button';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { useEffect, useRef, useState } from 'react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import ClientFormLayout from '../ClientFormLayout';
import ClientFormSteps from '../Partials/ClientFormSteps';
import useForm from "@/Utils/useForm";
var ClientForm = function (_a) {
    var clientForm = _a.clientForm, branch = _a.branch, client = _a.client;
    var route = useRoute(Ziggy);
    var firstFieldRef = useRef(null);
    var form = useForm(__assign({}, clientForm));
    var _b = useState(true), valid = _b[0], setValid = _b[1];
    useEffect(function () {
        var _a;
        (_a = firstFieldRef === null || firstFieldRef === void 0 ? void 0 : firstFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [0]);
    function validate() {
        if (form.data.client_confirmed_at) {
            setValid(true);
        }
        else {
            setValid(false);
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "border-b pb-6 mb-6" }, { children: _jsx(ClientFormSteps, { clientForm: clientForm, step: 5 }) })), _jsxs("div", __assign({ className: "sm:grid grid-cols-2 gap-6" }, { children: [_jsxs("div", __assign({ className: "space-y-6 mb-6" }, { children: [_jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx("input", { id: "confirm", name: "confirm", type: "checkbox", className: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", onChange: function (e) {
                                            if (e.target.checked) {
                                                form.setData('client_confirmed_at', new Date());
                                                validate();
                                            }
                                            else {
                                                form.setData('client_confirmed_at', null);
                                                validate();
                                            }
                                        } }), _jsx("label", __assign({ htmlFor: "confirm", className: "ml-2 block text-sm text-gray-900" }, { children: "I confirm that the information provided is correct" }))] })), _jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "comment", className: "block text-sm font-medium text-gray-700" }, { children: "Notes or questions" })), _jsx("textarea", { onChange: function (e) { return form.setData('client_notes', e.target.value); }, id: "client_notes", value: form.data.client_notes, className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" })] }), _jsxs(JetButton, __assign({ disabled: valid || form.processing, id: "continue", onClick: function () { return form.post(route('client-public-form.step-5.submit', { clientForm: clientForm })); }, className: "text-lg pr-2" }, { children: ["Confirm and submit ", _jsx(ChevronRightIcon, { className: "ml-2 h-5 w-5" })] }))] })), _jsx("div", { className: "p-6 bg-gray-50 rounded-lg shadow-inner text-gray-700" })] }))] }));
};
ClientForm.layout = ClientFormLayout;
export default ClientForm;
